import React from 'react';

/* External */
import { Tooltip } from '@material-ui/core';

/* Project */
import { TruncateText } from '../TruncateText';

export function TruncateTextToolTip({ text = '', lines = 1, classes = null, style = {} }) {
  return (
    <Tooltip title={text} placement="top">
      <div>
        <TruncateText text={text} lines={lines} classes={classes} style={style} />
      </div>
    </Tooltip>
  );
}
